import { TOKEN_KEY, USER_KEY, PATH_BEFORE_AUTH_KEY } from './config'
import { URLS } from './constants'

export const isAuthenticated = () => {
  return Boolean(localStorage.getItem(TOKEN_KEY))
}

export const authenticate = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

// set on successful user login
export const setUser = user => {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
  window.analytics.identify(user.uuid, {
    uuid: user.uuid,
    name: user.slackRealName,
    email: user.email,
    createdAt: user.dateJoined,
    avatar: user.slackImage48,
    isOrganizationAdmin: user.isOrganizationAdmin,
  })
}

export const getUser = () => {
  return JSON.parse(localStorage.getItem(USER_KEY))
}

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const deleteUser = () => {
  localStorage.removeItem(USER_KEY)
}

// export const getPageTitle = title => {
export const getPageTitle = () => {
  //
  // const topicTruncated =
  //   title.length > MAX_TITLE_LENGTH ? `${title.slice(0, MAX_TITLE_LENGTH)}...` : title
  // return `${topicTruncated} | Jellyfish`
  return 'Jellyfish'
}

export const submissionsClosed = board => {
  const { submissionEndDate, isArchived } = board
  return isArchived || Date.parse(submissionEndDate) < Date.now()
}

export const setPathBeforeAuth = () => {
  localStorage.setItem(PATH_BEFORE_AUTH_KEY, window.location.pathname)
  // console.log("window.location.pathname :"+window.location.pathname)
}

export const getPathBeforeAuthOrDefaultToDashboard = () => {
  let redirectPath = localStorage.getItem(PATH_BEFORE_AUTH_KEY)
  // console.log('redirectPath:'+redirectPath)
  if (redirectPath) {
    localStorage.removeItem(PATH_BEFORE_AUTH_KEY)
    return redirectPath
  }
  return URLS.DASHBOARD
}



// WEBPACK FOOTER //
// ./src/utils.js